'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var client = require('@apollo/client');
var nthHookLoma = require('@narvar/nth-hook-loma');
var graphql = require('./graphql.js');

const GlobalSettingsContext = /*#__PURE__*/react.createContext(undefined);
const LomaGlobalSettingsConfigContext = /*#__PURE__*/react.createContext({
  retailerMoniker: 'DEFAULT_RETAILER'
});
const nullGlobalSettings = {}; // maintains object ref equality
const LomaGlobalSettingsProvider = ({
  children,
  globalSettingsRequested
}) => {
  const client$1 = nthHookLoma.useLomaClient();
  const {
    retailerMoniker,
    localeCountry,
    localeLanguage,
    cache
  } = react.useContext(LomaGlobalSettingsConfigContext);
  const {
    loading,
    error,
    data
  } = client.useQuery(graphql["default"](globalSettingsRequested), {
    client: client$1,
    variables: {
      product: 'global',
      retailerMoniker,
      localeLanguage,
      localeCountry,
      cache
    }
  });
  const globalSettings = data?.globalSettings ?? nullGlobalSettings;
  const value = react.useMemo(() => ({
    loading,
    error,
    globalSettings
  }), [loading, error, globalSettings]);
  return /*#__PURE__*/react.createElement(GlobalSettingsContext.Provider, {
    value
  }, children);
};
const GlobalSettingsProviderContext = /*#__PURE__*/react.createContext(LomaGlobalSettingsProvider);
const LomaGlobalSettingsConfigProvider = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/react.createElement(GlobalSettingsProviderContext.Provider, {
    value: LomaGlobalSettingsProvider
  }, /*#__PURE__*/react.createElement(LomaGlobalSettingsConfigContext.Provider, {
    value: props
  }, children));
};
const GlobalSettingsProvider = ({
  children,
  ...props
}) => {
  const GlobalSettingsProvider = react.useContext(GlobalSettingsProviderContext);
  return /*#__PURE__*/react.createElement(GlobalSettingsProvider, props, children);
};
const withGlobalSettingsProvider = (component, options) => {
  const {
    globalSettingsRequested
  } = options;
  const HoC = /*#__PURE__*/react.forwardRef((props, ref) => {
    return /*#__PURE__*/react.createElement(GlobalSettingsProvider, {
      globalSettingsRequested
    }, /*#__PURE__*/react.createElement(component, {
      ...props,
      ref
    }));
  });
  const name = component.displayName ?? component.name;
  HoC.displayName = `WithGlobalSettingsProvider(${name})`;
  return HoC;
};
const useGlobalSettings = () => {
  const context = react.useContext(GlobalSettingsContext);
  if (!context) {
    throw new Error('useGlobalSettings was called without a GlobalSettingsContext');
  }
  return context.globalSettings;
};
const useGlobalSettingsX = () => {
  const context = react.useContext(GlobalSettingsContext);
  if (!context) {
    throw new Error('useGlobalSettingsX was called without a GlobalSettingsContext');
  }
  return context;
};
const LocalGlobalSettingsConfigContext = /*#__PURE__*/react.createContext({
  queryGlobalSettings: () => {
    throw new Error('Not implemented');
  }
});
const LocalGlobalSettingsProvider = ({
  children,
  ...props
}) => {
  const config = react.useContext(LocalGlobalSettingsConfigContext);
  const value = config.queryGlobalSettings(props);
  return /*#__PURE__*/react.createElement(GlobalSettingsContext.Provider, {
    value
  }, children);
};
const LocalGlobalSettingsConfigProvider = ({
  children,
  ...props
}) => /*#__PURE__*/react.createElement(GlobalSettingsProviderContext.Provider, {
  value: LocalGlobalSettingsProvider
}, /*#__PURE__*/react.createElement(LocalGlobalSettingsConfigContext.Provider, {
  value: props
}, children));

exports.globalSettingsQuery = graphql["default"];
exports.GlobalSettingsProvider = GlobalSettingsProvider;
exports.LocalGlobalSettingsConfigProvider = LocalGlobalSettingsConfigProvider;
exports.LocalGlobalSettingsProvider = LocalGlobalSettingsProvider;
exports.LomaGlobalSettingsConfigProvider = LomaGlobalSettingsConfigProvider;
exports.useGlobalSettings = useGlobalSettings;
exports.useGlobalSettingsX = useGlobalSettingsX;
exports.withGlobalSettingsProvider = withGlobalSettingsProvider;
